var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigateRightButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Right_Circle",
    "data-name": "Arrow - Right Circle",
    transform: "translate(0 20) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow_-_Right_Circle-2",
    "data-name": "Arrow - Right Circle",
    d: "M0,10A10,10,0,1,1,10,20,10.011,10.011,0,0,1,0,10Zm1.5,0A8.5,8.5,0,1,0,10,1.5,8.51,8.51,0,0,0,1.5,10Zm8.052,2.646-.085-.073L6,9.087a.75.75,0,0,1,.978-1.131l.085.073L10,10.98l2.94-2.951a.749.749,0,0,1,.976-.075L14,8.026A.751.751,0,0,1,14.075,9L14,9.087l-3.471,3.486a.75.75,0,0,1-.978.073Z",
    transform: "translate(0)",
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateRightButtonIcon);
export default __webpack_public_path__ + "static/media/navigate-right-button-icon.35d7a6fcb20b90a1d475cc2dd7f47eb4.svg";
export { ForwardRef as ReactComponent };